export const mobileSteps = [
  'Не змінюйте ЄДРПОУ, реквізити отримувача та призначення платежу.',
  'Не використовуйте функцію «Повторити платіж» у банківському застосунку (кошти не зарахуються).',
  'Для кожного поповнення потрібно створювати нову транзакцію на сайті.',
];

export const desktopSteps = [
  'Відкрийте банківський застосунок і відскануйте QR-код в цьому додатку.',
  'Не змінюйте ЄДРПОУ, реквізити отримувача та призначення платежу.',
  'Не використовуйте функцію «Повторити платіж» для інших платежів у банківському застосунку (кошти не зарахуються).',
  'Для нового поповнення потрібно згенерувати новий QR-код (створити нову транзакцію).',
];
